import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import PublicCustomer from "./pages/PublicCustomer";
import "./styles/Main.css";
import NavBar from "./components/NavBar";
import { UserState } from "./context/UserState";

export default function App() {
  return (
    <div>
      <BrowserRouter>
        <UserState>
          <NavBar />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/cliente/:slug" element={<PublicCustomer />} />
          </Routes>
        </UserState>
      </BrowserRouter>
    </div>
  );
}